import React from 'react';

const Dropdown = ({ options, onChange, label, value }) => {
  return (
    <div style={{ /*margin: '10px'*/ }}>
      {label && (
        <label style={{
          display: 'block',  
          marginBottom: '5px',
          fontSize: '12px',    
          color: 'var(--primary-white-color)'
        }}>
          {label}
        </label>
      )}

      <select 
        value={value} 
        onChange={(e) => onChange(e.target.value)} // Ensure this updates the parent state
        style={{
          padding: '3px',
          borderRadius: '10px',
          border: '1px solid #ccc',
          backgroundColor: 'var(--primary-white-color)',
          fontSize: '12px', 
          fontFamily: 'KomikaAxis',
          color:'var(--primary-color)', 
          fontWeight: 'normal', 
          maxWidth: '250px',
        }}
      >
        {options.map((option, index) => {
          const isObject = typeof option === 'object';
          return (
            <option key={index} value={isObject ? option.value : option}>
              {isObject ? option.label : option} {/* Handle both strings and objects */}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default Dropdown;
